module.exports = __webpack_public_path__ + "img/overdue.08a595b0.svg";